import { arrayOf, node, oneOfType } from 'prop-types'
import { isNilOrEmpty } from 'ramda-adjunct'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import React from 'react'
import STORE_NAMESPACES from 'store/namespaces'

import digilianceLogo from 'assets/digiliance-logo.svg'
import logo from 'assets/logo-horizontal.png'

import Footer from './Footer'
import Header from './Header'
import useStyles from './styles'

const Layout = ({ children }) => {
  const classes = useStyles()
  const location = useLocation().pathname
  const { token } = useSelector(state => state[STORE_NAMESPACES.SECURITY])

  return (
    <>
      <Header sx={{ flex: 1 }} logo={logo} />
      <main className={classes.main} id="main">
        {children}
      </main>
      {!isNilOrEmpty(token) && location !== '/auth/logout' && (
        <Footer logo={digilianceLogo} />
      )}
    </>
  )
}

Layout.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
}

export default Layout
